/* Initialize Flickity */
let options = {
  prevNextButtons: true,
  pageDots: true,
  draggable: false,
  contain: true,
  cellAlign: 'left',
  adaptiveHeight: true,
  dragThreshold: 8,
  groupCells: 2
};

if ( matchMedia('screen and (min-width: 1024px)').matches ) {

  $('.main-carousel').flickity({
    groupCells: 3,
  })
}

if ( matchMedia('screen and (max-width: 768px)').matches ) {
  options.groupCells = 1;
}

$('.main-carousel').flickity( options );

/* ------------------------------------------------------------
   EU guarantee flyer popup (snippets/product-block-guarantee-popup.liquid)
   Native <dialog>: Esc and focus trapping are handled by the browser.
   Delegated listeners so it survives theme-editor section re-renders.
   ------------------------------------------------------------ */
(function () {
  var lastTrigger = null;

  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    lastTrigger = trigger || null;
    document.documentElement.classList.add('guarantee-dialog-open');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      onClosed(dialog);
    }
  }

  function setZoom(dialog, zoomed, point) {
    var button = dialog.querySelector('[data-guarantee-zoom]');
    var media = dialog.querySelector('[data-guarantee-media]');
    var body = dialog.querySelector('[data-guarantee-body]');
    var image = media && media.querySelector('img');
    if (!button || !media || !image) return;

    // Relative click position, so zooming in keeps that spot in view.
    var rx = 0.5, ry = 0;
    if (point) {
      var rect = image.getBoundingClientRect();
      rx = (point.x - rect.left) / rect.width;
      ry = (point.y - rect.top) / rect.height;
    }

    dialog.classList.toggle('is-zoomed', zoomed);
    button.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    var label = button.querySelector('[data-guarantee-zoom-label]');
    if (label) label.textContent = zoomed ? button.dataset.labelOut : button.dataset.labelIn;

    // Let the browser pick a sharper srcset candidate at the zoomed width.
    if (!image.dataset.sizes) image.dataset.sizes = image.getAttribute('sizes') || '';
    image.setAttribute('sizes', zoomed ? '(min-width: 768px) 2250px, 300vw' : image.dataset.sizes);

    if (zoomed) {
      media.scrollLeft = rx * image.offsetWidth - media.clientWidth / 2;
      if (point) body.scrollTop = ry * image.offsetHeight - body.clientHeight / 2;
    } else {
      media.scrollLeft = 0;
    }
  }

  function onClosed(dialog) {
    document.documentElement.classList.remove('guarantee-dialog-open');
    setZoom(dialog, false);
    var body = dialog.querySelector('[data-guarantee-body]');
    if (body) body.scrollTop = 0;
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-guarantee-open]');
    if (trigger) {
      openDialog(document.getElementById(trigger.getAttribute('data-guarantee-open')), trigger);
      return;
    }

    var dialog = event.target.closest('.guarantee-dialog');
    if (!dialog) return;

    // The inner wrapper covers the whole dialog box, so a click whose
    // target is the <dialog> itself landed on the backdrop.
    if (event.target === dialog) {
      closeDialog(dialog);
      return;
    }

    if (event.target.closest('[data-guarantee-close]')) {
      closeDialog(dialog);
      return;
    }

    if (event.target.closest('[data-guarantee-zoom]')) {
      setZoom(dialog, !dialog.classList.contains('is-zoomed'));
      return;
    }

    if (event.target.closest('.guarantee-dialog__image')) {
      var zoomIn = !dialog.classList.contains('is-zoomed');
      setZoom(dialog, zoomIn, zoomIn ? { x: event.clientX, y: event.clientY } : null);
    }
  });

  // 'close' doesn't bubble, so listen in the capture phase.
  document.addEventListener('close', function (event) {
    if (event.target.classList && event.target.classList.contains('guarantee-dialog')) {
      onClosed(event.target);
    }
  }, true);

  // Theme editor: open the popup while its block is selected.
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target.closest && event.target.closest('[data-guarantee-block]');
    if (block) openDialog(block.querySelector('.guarantee-dialog'), block.querySelector('[data-guarantee-open]'));
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var block = event.target.closest && event.target.closest('[data-guarantee-block]');
    if (block) closeDialog(block.querySelector('.guarantee-dialog'));
  });

  // Section re-render in the editor removes an open dialog without a 'close' event.
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('guarantee-dialog-open');
  });
})();
